export default {
  "components-payment-link": () => import("/app/layouts/_components/PaymentLink.vue").then(m => m.default || m),
  "components-payment-link-result": () => import("/app/layouts/_components/PaymentLinkResult.vue").then(m => m.default || m),
  "components-payment-link-terms": () => import("/app/layouts/_components/PaymentLinkTerms.vue").then(m => m.default || m),
  "components-reserve-flow-header": () => import("/app/layouts/_components/ReserveFlowHeader.vue").then(m => m.default || m),
  "components-reserve-flow-stepper": () => import("/app/layouts/_components/ReserveFlowStepper.vue").then(m => m.default || m),
  app: () => import("/app/layouts/app.vue").then(m => m.default || m),
  "buy-flow": () => import("/app/layouts/buyFlow.vue").then(m => m.default || m),
  constant: () => import("/app/layouts/constant.ts").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  error: () => import("/app/layouts/error.vue").then(m => m.default || m),
  homepage: () => import("/app/layouts/homepage.vue").then(m => m.default || m),
  "hybrid-reserve": () => import("/app/layouts/hybridReserve.vue").then(m => m.default || m),
  landing: () => import("/app/layouts/landing.vue").then(m => m.default || m),
  panel: () => import("/app/layouts/panel.vue").then(m => m.default || m),
  pure: () => import("/app/layouts/pure.vue").then(m => m.default || m),
  "reserve-flow": () => import("/app/layouts/reserve-flow.vue").then(m => m.default || m),
  reserve: () => import("/app/layouts/reserve.vue").then(m => m.default || m),
  "use-layout": () => import("/app/layouts/useLayout.ts").then(m => m.default || m)
}